import { createAppTestIds } from './index';

/**
 * Test IDs for Dropbox integration
 */
export const DROPBOX_TEST_IDS = {
  ...createAppTestIds('dropbox-app'),
  exportSettingsModal: 'dropbox-export-settings-modal',
  exportSettingsButton: 'dropbox-export-settings-button',
  exportSettings: 'dropbox-export-settings',
} as const;
